
import { isEmpty } from '~/utils/Utils'

export default {
  name: 'BaseFormActionsPage',
  props: {
    page: {
      type: Number,
      required: true,
    },

    pagesCount: {
      type: Number,
      required: true,
    },

    submitText: {
      type: String,
      default: 'Save',
    },

    isFirstPrevBtnEnabled: {
      type: Boolean,
      default: false,
    },

    questionnaireNavColor: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isDefaultColor () {
      return !isEmpty(this.questionnaireNavColor)
    },
  },
}
